module.exports = __webpack_public_path__ + "img/gas_icon.a54b3c90.png";